import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { IconFast, IconAI, IconCloud, IconTarget, IconFullStack, IconShield, IconUsers } from '../components/Icons';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about mesh-gradient">
      <Hero
        title="About Apres AI"
        subtitle="We're a small but mighty team of AI-forward developers passionate about turning innovative ideas into successful businesses."
      />

      <section className="mission animate-fade-in-up">
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p>
            At Apres AI, we believe that great ideas shouldn't be held back by technical 
            barriers. Our mission is to bridge the gap between innovative concepts and 
            market-ready products by leveraging the power of AI and modern development practices.
          </p>
          
          <div className="values">
            <Card
              variant="value"
              icon={<IconFast />}
              title="Speed & Agility"
              description="We move fast without breaking things, delivering MVPs and full products in weeks, not months."
            />
            <Card
              variant="value"
              icon={<IconAI />}
              title="AI-First Approach"
              description="We integrate AI at every level - from development processes to the products we build."
            />
            <Card
              variant="value"
              icon={<IconCloud />}
              title="Quality & Scale"
              description="Built for growth with robust, scalable architectures using modern cloud technologies."
            />
          </div>
        </div>
      </section>

      <section className="charter animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
        <div className="charter-content">
          <h2>Our Charter</h2>
          <div className="charter-points">
            <Card
              variant="value"
              icon={<IconTarget />}
              title="Rapid Prototyping"
              description="Transform ideas into working prototypes within days using AI-assisted development tools and modern frameworks."
            />
            <Card
              variant="value"
              icon={<IconFullStack />}
              title="Full-Stack Solutions"
              description="End-to-end development covering frontend, backend, infrastructure, and mobile applications."
            />
            <Card
              variant="value"
              icon={<IconShield />}
              title="Business-Ready Products"
              description="Not just demos - we build production-ready applications with proper architecture, security, and scalability."
            />
            <Card
              variant="value"
              icon={<IconUsers />}
              title="Partnership Approach"
              description="We work closely with founders and innovators to understand their vision and translate it into technical reality."
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;